import React, { useState, useEffect, useMemo } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp, MdSearch } from 'react-icons/md';
import ReactTooltip from "react-tooltip";
import api from '~/services/api';
import Steps from '~/components/steps/Steps';
import Reaptcha from 'reaptcha';
import { ButtonPadraoPrimary } from '~/styles/CommonStyles';
import {
    Container,
    TodosAlimentos,
    ContainerListaAlimentos,
    Alimento,
    BtnSelecionar,
    BtnRemover,
    InputBusca,
    ContainerSetas,
    BtnSalvar,
    BtnCancelar
} from './stylesRecordatorio';

import Toastify from "~/components/Toastify";
import getUrlParameter from '~/helpers/getURLencode';
import { useRecoilState } from 'recoil';
import { mensagemConformidadeLGPD } from '../../atoms/conformidade';

let Etapas = [
    { name: 'Cafe', text: 'Café da manhã' },
    { name: 'Colacao', text: 'Colação' },
    { name: 'Almoco', text: 'Almoço' },
    { name: 'Lanche', text: 'Lanche da tarde' },
    { name: 'Janta', text: 'Jantar' },
    { name: 'Ceia', text: 'Ceia' },
    { name: 'Refeicao1', text: 'Pré Treino/1ª refeição extra' },
    { name: 'Refeicao2', text: 'Pré Treino/2ª refeição extra' },
];

function Recordatorio ( { location } ) {
    const params = new URLSearchParams( location.search );
    const _CHAVE = params.get( 'chave' );

    const [ recaptchaToken, setRecaptchaToken ] = useState( null );

    const [ etapa, setEtapa ] = useState( 0 );
    const [ alimentos, setAlimentos ] = useState( [] ); // {idAlimento:1, qtn:1, refeicao:1}
    const [ alimentosSelecionados, setAlimentosSelecionados ] = useState( [] ); // {idAlimento:1, qtn:1, refeicao:1}
    const [ buscaAlimento, setBuscaAlimento ] = useState( '' );
    const [ conclusao, setConclusao ] = useState( false );
    const [ comentarioPac, setComentarioPac ] = useState( '' );
    const [ conformidadeMensagem, setConformidadeMensagem ] = useRecoilState( mensagemConformidadeLGPD );

    useEffect( () => {
        console.log( 'Etapas: ', etapa );
        setBuscaAlimento( '' );
    }, [ etapa ] );

    useEffect( () => {
        getAlimentosComuns();
        setConformidadeMensagem( { popUpOpen: true } );
    }, [] );


    async function getAlimentosComuns ( params ) {
        try {
            let response = await api.get( 'apoio/getAlimentosComuns' );

            setAlimentos( response.data );
        } catch ( error ) {
            console.log( error );
            Toastify.error( `Erro. ${ error.response.data }` );
        }
    };

    function selecionaAlimento ( alimento ) {
        if ( alimentosSelecionados.filter( alimento => alimento.Grupo == etapa ).findIndex( alimentoSelecionado => alimentoSelecionado.Id_do_Alimento === alimento.Id_do_Alimento ) !== -1 )
            return Toastify.warning( 'Alimento já selecionado nesta refeição' );
        setAlimentosSelecionados( old => [ ...old, { ...alimento, Grupo: etapa, Qtd: 1 } ] );
    };

    function removeAlimento ( alimento ) {
        let indexAlimentoJaSelecionado = alimentosSelecionados.findIndex( alimentoSelecionado => alimentoSelecionado.Id_do_Alimento === alimento.Id_do_Alimento && alimentoSelecionado.Grupo == etapa );
        alimentosSelecionados.splice( indexAlimentoJaSelecionado, 1 );
        setAlimentosSelecionados( [ ...alimentosSelecionados ] );
    };

    function almentarQtd ( alimento, soma ) {
        let indexAlimentoJaSelecionado = alimentosSelecionados.findIndex( alimentoSelecionado => alimentoSelecionado.Id_do_Alimento === alimento.Id_do_Alimento && alimentoSelecionado.Grupo == etapa );

        if ( soma ) {
            alimentosSelecionados[ indexAlimentoJaSelecionado ].Qtd = alimentosSelecionados[ indexAlimentoJaSelecionado ].Qtd + 0.5;
        } else {
            if ( alimentosSelecionados[ indexAlimentoJaSelecionado ].Qtd > 0.5 )
                alimentosSelecionados[ indexAlimentoJaSelecionado ].Qtd = alimentosSelecionados[ indexAlimentoJaSelecionado ].Qtd - 0.5;
        }
        setAlimentosSelecionados( [ ...alimentosSelecionados ] );
    };

    function proximaEtapa ( etapa, ultima = false ) {
        if ( ultima ) {
            setConclusao( true );
        }
        setEtapa( etapa );
    };

    async function salvarRecordatorio () {
        try {
            if ( !_CHAVE )
                return Toastify.error( 'Por favor, peça que seu medico te envie outro link para respoder o questionario. ' );
            if ( !recaptchaToken )
                return Toastify.warning( 'Por favor, faça a verificação do "captcha" ' );

            let { data } = await api.post( `/apoio/saveRecordatorio`, { Chave: _CHAVE, responsecaptcha: recaptchaToken, comentarios: comentarioPac, recordatorioItems: alimentosSelecionados } );

            Toastify.success( 'Diário alimentar enviado com sucesso' );
            return data;
        } catch ( error ) {
            console.log( error );
            Toastify.error( 'Erro ao salvar dados, por favor entre em contato com seu médico' );
            return Promise.reject( error );;
        }
    }

    const listaAlimentosFiltrados = useMemo( () => {
        if ( buscaAlimento.length == 0 )
            return [ ...alimentos ];

        return alimentos.filter( alimento => alimento.Alimento.toUpperCase().includes( buscaAlimento.toUpperCase() ) );

    }, [ buscaAlimento, alimentos ] );

    return !conclusao ?
        <Container>
            <h1>Meu Diário Alimentar</h1>
            <span >
                *Recomendamos preencher o recordatorio em um computador.
                Selecione na caixa abaixo os alimentos e bebidas que costuma consumir nessa refeição em um <strong>dia típico da sua rotina</strong>.
            </span>
            <div style={ { margin: '15px 0px', height: '40px' } }>
                <Steps data={ Etapas } value={ etapa } manipulador={ proximaEtapa } />
            </div>
            <TodosAlimentos >
                <ContainerListaAlimentos style={ { paddingLeft: '0px' } }>
                    <div style={ { display: 'flex', justifyContent: 'center', alignItems: 'center', } }>
                        <div style={ { position: 'relative', marginLeft: '5px' } }>
                            <MdSearch style={ { position: 'absolute', left: '-2px', top: '3px', fontSize: '18px' } } />
                            <InputBusca type="text" value={ buscaAlimento } placeholder="Buscar Alimento" onChange={ ( e ) => setBuscaAlimento( e.target.value ) } />

                        </div>
                    </div>
                    <div style={ { display: 'flex', height: '100%', overflowY: 'auto', overflowX: 'hidden', flexDirection: 'column' } }>
                        { listaAlimentosFiltrados.map( alimento => (
                            <Alimento key={ alimento.Id_do_Alimento } >
                                <span>{ alimento.Alimento }</span>
                                <BtnSelecionar onClick={ () => selecionaAlimento( alimento ) } >Selecionar</BtnSelecionar>
                            </Alimento>
                        ) ) }
                    </div>
                </ContainerListaAlimentos>

                <ContainerListaAlimentos style={ { paddingRight: '0px' } }>
                    <h2>Alimentos Selecionados <b style={ { color: 'var(--primaryColor)' } }>{ `(${ Etapas[ etapa ].text })` }</b>  </h2>
                    <div style={ { display: 'flex', height: '100%', overflowY: 'auto', overflowX: 'hidden', flexDirection: 'column' } }>
                        { alimentosSelecionados.filter( alimento => alimento.Grupo == etapa ).map( alimento => (
                            <Alimento key={ `${ alimento.Id_do_Alimento }-selec` } >
                                <BtnRemover onClick={ () => removeAlimento( alimento ) } >Remover</BtnRemover>
                                <span>{ alimento.Alimento }</span>
                                <div style={ { display: 'flex', alignItems: 'center', justifyContent: 'center' } }>
                                    <ContainerSetas>
                                        <MdKeyboardArrowUp onClick={ () => almentarQtd( alimento, true ) } />
                                        <MdKeyboardArrowDown onClick={ () => almentarQtd( alimento, false ) } />
                                    </ContainerSetas>
                                    <span>{ alimento.Qtd.toFixed( 2 ) }</span>
                                    <span>x</span>
                                </div>

                            </Alimento>
                        ) ) }
                    </div>
                </ContainerListaAlimentos>
            </TodosAlimentos>
        </Container >
        :
        <Container>
            <h1>Meu Diário Alimentar</h1>
            <span >
                Por favor verifique os alimentos selecionados para e caso precise voce pode deixar
                um comentario para seu médico a respeito do seu diario alimentar.
            </span>
            <div style={ { width: '100%', height: '100px' } }>
                <textarea value={ comentarioPac } onChange={ ( e ) => setComentarioPac( e.target.value ) } style={ { width: '100%', height: '100%' } } placeholder="Deixe aqui um comentario caso ache necessário"></textarea>
            </div>
            <div style={ { display: 'flex', flexDirection: 'column', width: '100%', height: '100%' } }>
                <div style={ { display: 'flex', flexDirection: 'column', width: '100%', height: '100%' } }>
                    { alimentosSelecionados.sort( function ( a, b ) {
                        if ( a.Grupo > b.Grupo ) {
                            return 1;
                        }
                        if ( a.Grupo < b.Grupo ) {
                            return -1;
                        }
                        // a must be equal to b
                        return 0;
                    } ).map( alimento => {
                        return (
                            <div>
                                <span style={ { fontWeight: '700' } }>{ Etapas[ alimento.Grupo ].text }</span>
                                <span> - { alimento.Alimento } - </span>
                                <span>{ alimento.Qtd.toFixed( 2 ) }x</span>
                            </div>
                        );
                    } ) }
                </div>
                <div style={ { display: 'flex', justifyContent: 'center', margin: '10px 0px' } }>
                    <Reaptcha
                        sitekey="6LfrDqgZAAAAABATEykmT5tqdYVnvx0B7Fm3Ahj3"
                        onVerify={ ( value ) => setRecaptchaToken( value ) }
                        onExpire={ () => setRecaptchaToken( null ) }
                    />

                </div>
                <div style={ { display: 'flex', gap: '10px', width: '100%', justifyContent: 'center' } }>
                    <ButtonPadraoPrimary cancel onClick={ () => setConclusao( false ) }>Voltar</ButtonPadraoPrimary>
                    <a data-tip data-for='btnHome' >
                        <ButtonPadraoPrimary style={ { width: '300px' } } disabled={ !recaptchaToken } onClick={ () => salvarRecordatorio() }>Enviar</ButtonPadraoPrimary>
                    </a>
                    <ReactTooltip delayShow={ 300 } id='btnHome' place="bottom" type="dark" effect="solid">
                        { recaptchaToken ? <span>Enviar </span> : <span>Antes selecione o captcha de verificação (Não sou o robô)</span> }
                    </ReactTooltip>
                </div>
            </div>
        </Container>;
};

export default Recordatorio;




